<template>
    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-12">
                    <h2>Advertisement Payment</h2>
                </div>
            </div>
            <div class="row mt-3 p-3">
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="">Invoice Number</label>
                        <input type="text" class="form-control" placeholder="Invoice Number" v-model="affiliatePaymnetDetails.invoice_number">
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="">Invoice Total Amount</label>
                        <input type="number" class="form-control" placeholder="Invoice Amount" step="0.01" v-model="affiliatePaymnetDetails.invoice_amount">
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="">Due date</label>
                        <input type="date" class="form-control" placeholder="Due date"  v-model="affiliatePaymnetDetails.invoice_due_date">
                    </div>
                </div>
            </div>
            <div class="row mt-3 p-3">
                <div class="col-md-3">
                    <div class="form-group">
                        <label for="payment_mode"> Payment mode </label>
                        <v-select
                            id="payment_mode"
                            :options="['Bax','Card','checque','cash','bank']"
                            placeholder="Payment mode"
                            v-model="affiliatePaymnetDetails.payment_mode"
                            />
                    </div>
                </div> 
                <div class="col-md-3">
                    <div class="form-group">
                        <label for="payment_number">Payment number</label>
                        <input id="payment_number" class="form-control"  type="text" placeholder="Payment number"  v-model="affiliatePaymnetDetails.payment_mode_number">
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label for="paid_date"> Paid Date </label>
                        <input id="paid_date" class="form-control"  type="date" placeholder="Paid date" v-model="affiliatePaymnetDetails.payment_date">
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label for="paid_amount"> Paid Amount </label>
                        <input id="paid_amount" class="form-control"  type="number" step="0.01" placeholder="Paid Amount" v-model="affiliatePaymnetDetails.payment_amount">
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-md-12">
                <div class="form-wrap">
                    <div class="form-submit-inline">
                    <button class="button" @click="updateAddwordPayment">
                        <span> Update Payment Details  </span>
                    </button>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AdvertisementInvoicePayment',
    props: {
        affiliatePaymnetDetails: {
            type: Object,
            default: {}
        }
    },
    methods: {
        updateAddwordPayment() {
            let self = this
            self.$store.dispatch('setLoadStatus')
            fetch(`${self.$api}affiliates/advertisement/update-payment-details`, {
                method: 'POST',
                body: JSON.stringify({
                    ...self.affiliatePaymnetDetails
                }),
                headers:{
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
                self.errors = response.errors
                if (response.status) {
                    this.$swal({
                        icon: "success",
                        title: response.message,
                    }).then(() => {
                        self.$emit('closeModal')
                    })
                } 
                
            }).finally(() => {
                self.$store.dispatch('setLoadStatus')
            });
        }
    }        
}
</script>

<style lang="scss" scoped>

</style>